export const HEADERS = {
  'Content-Type':     'application/json',
  'Accept':           'application/json',
  'X-Requested-With': 'XMLHttpRequest',
  'Cache-Control':    'no-cache',
  'X-CSRF-Token':     document.querySelector('meta[name="csrf-token"]').getAttribute('content')
}

export const STATUSES = {
  OPEN:        'open',
  SCHEDULED:   'scheduled',
  CLOSED:      'closed',
  IN_PROGRESS: 'in-progress'
}

export const PROXIMITY = {
  CONFIRMED:   'confirmed',
  REFUSED:     'refused',
  BLOCKED:     'blocked',
  UNAVAILABLE: 'unavailable'
}

export const DEMAND_STATUSES = {
  OPEN:        'Open',
  ACCEPTED:    'Accepted',
  IN_PROGRESS: 'InProgress',
  REJECTED:    'Rejected',
  DONE:        'Closed'
}

export const TYPES = {
  REACTIVE:     'Reactive',
  PREVENTIVE:   'Preventive',
  INSTALLATION: 'Installation'
}

export const DIRECTIONS = {
  DESC: 'desc',
  ASC:  'asc'
}

export const MODELS = {
  CLIENTS:   'clients',
  SITES:     'sites',
  MATERIALS: 'materials',
  PRODUCTS:  'products',
  METERS:    'meters',
}

export const MODELS_ICONS = {
  [MODELS.CLIENTS]:   "user",
  [MODELS.SITES]:     "building",
  [MODELS.MATERIALS]: "memory"
}

export const SIGNATURES = {
  MANDATORY: 'Mandatory',
  OPTIONAL:  'Optional',
  DISABLED:  'Disabled'
}

export const FIELD_ANSWER_TYPES = {
  text:           "text",
  checkbox:       "checkbox",
  date:           "date",
  dateTime:       "date_time",
  number:         "number",
  float:          "float",
  select:         "select",
  yesNo:          "yes_no",
  description:    "description",
  select_prefill: "select_prefill",
  static:         "static",
  break:          "page_break",
  sign:           "e_sign",
  photos:         "photos",
  table:          "table"
}

export const PULL_TO_REFRESH_SIZE = 150
export const MANAGER      = 'manager'
export const TECHNICIAN   = 'technician'
export const GUEST        = 'guest'

const mapQuery = (date, technician) => {
  const query = new URLSearchParams()
  if (date)       query.set('date', date)
  if (technician) query.set('technician', technician)
  const string = query.toString()
  return string ? `?${string}` : ''
}

export const PATHS = {
  scan: {
    show:    '/mobile/scan',
    resolve: '/mobile/scan.json'
  },
  home: {
    index:        '/mobile/home',
    summary:      '/mobile/home/summary.json',
    search:       '/mobile/searches.json',
    searchResult: id => `/mobile/searches/${id}.json`,
  },
  clients: {
    index:        '/mobile/clients',
    autocomplete: '/mobile/clients/autocomplete',
    show:         id => `/mobile/clients/${id}`,
    get:          id => `/mobile/clients/${id}.json`,
    fetch:        id => `/mobile/clients/${id}.json?database=true`,
  },
  sites: {
    index:        '/mobile/sites',
    autocomplete: '/mobile/sites/autocomplete',
    show:         id => `/mobile/sites/${id}`,
    fetch:        id => `/mobile/sites/${id}.json`,
    update:       id => `/mobile/sites/${id}`,
    history:      id => `/mobile/sites/${id}/history.json`,
    gallery:      id => `/mobile/sites/${id}/gallery.json`,
    equipmentGrid:      id => `/mobile/sites/${id}/equipment_grid`,
    equipmentGridFetch: id => `/mobile/sites/${id}/equipment_grid.json`,
    newWorkorder: site => `/mobile/interventions/new?client=${site.client.id}&site=${site.id}`
  },
  materials: {
    index:        '/mobile/materials',
    autocomplete: '/mobile/materials/autocomplete',
    scan:         '/mobile/materials/scan.json',
    create:       '/mobile/materials.json',
    show:         id => `/mobile/materials/${id}`,
    fetch:        id => `/mobile/materials/${id}.json`,
    edit:         id => `/mobile/materials/${id}/edit`,
    patch:        id => `/mobile/materials/${id}/edit.json`,
    update:       id => `/mobile/materials/${id}`,
    history:      id => `/mobile/materials/${id}/history`,
    gallery:      id => `/mobile/materials/${id}/gallery`,
    photos:       id => `/mobile/materials/${id}/photos`,
    nameplate:    '/mobile/materials/nameplate',
    new:          siteId =>   `/mobile/materials/new?site=${siteId}`,
    build:        siteId =>   `/mobile/materials/new?site=${siteId}.json`,
    newWorkorder: material => `/mobile/interventions/new?client=${material.client.id}&site=${material.site.id}&material=${material.id}`,
    newDemand:    material => `/mobile/demands/new?client=${material.client.id}&site=${material.site.id}&material=${material.id}`
  },
  downtimes: {
    new:    materialId               => `/mobile/materials/${materialId}/downtimes/new`,
    create: materialId               => `/mobile/materials/${materialId}/downtimes`,
    edit:   (materialId, downtimeId) => `/mobile/materials/${materialId}/downtimes/${downtimeId}/edit`,
    update: (materialId, downtimeId) => `/mobile/materials/${materialId}/downtimes/${downtimeId}`,
    delete: (materialId, downtimeId) => `/mobile/materials/${materialId}/downtimes/${downtimeId}`,
  },
  meters: {
    index:    '/mobile/meters',
    filter:   '/mobile/meters.json',
    show:     id => `/mobile/meters/${id}`,
    fetch:    id => `/mobile/meters/${id}.json`,
    readings: workorderId => `/mobile/meters/readings.json?workorder=${workorderId}`
  },
  readings: {
    create:  meterId => `/mobile/meters/${meterId}/readings`,
    destroy: id      => `/mobile/readings/${id}`
  },
  invoices: {
    show:        id => `/mobile/invoices/${id}`,
    update:      id => `/mobile/invoices/${id}`,
    confirm:     id => `/mobile/invoices/${id}/confirm`,
    add_payment: id => `/mobile/invoices/${id}/add_payment`,
    remove_line: id => `/mobile/invoices/${id}/remove_line`
  },
  workorders: {
    index:           '/mobile/interventions',
    count:           '/mobile/interventions/count',
    filter_options:  '/mobile/interventions/filter_options',
    calendar:  '/mobile/interventions/calendar.json',
    new:       '/mobile/interventions/new',
    create:    '/mobile/interventions',
    fetch:     id => `/mobile/interventions/${id}.json`,
    fetchData: id => `/mobile/interventions/${id}/fetch_data.json`,
    show:      id => `/mobile/interventions/${id}`,
    version:   id => `/mobile/interventions/${id}/version.json`,
    sync:      id => `/mobile/interventions/${id}/sync.json`,
    update:    id => `/mobile/interventions/${id}`,
    take:      id => `/mobile/interventions/${id}/take.json`,
    invoice:   id => `/mobile/interventions/${id}/invoice`,
    group:     id => `/mobile/interventions/${id}/group`,
    related:   id => `/mobile/interventions/${id}/related`,
    products: {
      create:   wo      => `/mobile/interventions/${wo}/products.json`,
      parts:    wo      => `/mobile/interventions/${wo}/products/spare_parts.json`,
      update:  (wo, id) => `/mobile/interventions/${wo}/products/${id}.json`,
      delete:  (wo, id) => `/mobile/interventions/${wo}/products/${id}.json`,
      fetch:   (wo, id) => `/mobile/interventions/${wo}/products/${id}/fetch_install.json`,
      install: (wo, id) => `/mobile/interventions/${wo}/products/${id}/install.json`,
    },
    placement: wo => `/mobile/interventions/${wo}/placement.json`,
    photos: {
      create:  wo       => `/mobile/interventions/${wo}/photos.json`,
      destroy: (wo, id) => `/mobile/interventions/${wo}/photos/${id}.json`
    },
    quotes: {
      demand: workorderId            => `/mobile/interventions/${workorderId}/quotes.json`,
      update: (workorderId, quoteId) => `/mobile/interventions/${workorderId}/quotes/${quoteId}.json`
    },
    preventive: {
      fetch:  wo        => `/mobile/interventions/${wo}/preventive.json`,
      update: (wo, id)  => `/mobile/interventions/${wo}/preventive/${id}.json`
    },
    tasksGrid: wo => `/mobile/interventions/${wo}/tasks_grid`,
    materialChecks: {
      show:    wo                => `/mobile/interventions/${wo}/equipment_grid`,
      index:   wo                => `/mobile/interventions/${wo}/material_checks.json`,
      create:  wo                => `/mobile/interventions/${wo}/material_checks.json`,
      destroy: (wo, materialId)  => `/mobile/interventions/${wo}/material_checks/${materialId}.json`
    },
    materials: {
      index:    wo      => `/mobile/interventions/${wo}/materials`,
      create:   wo      => `/mobile/interventions/${wo}/materials`,
      destroy: (wo, id) => `/mobile/interventions/${wo}/materials/${id}`
    },
    blueprint_answers: {
      create:   wo      => `/mobile/interventions/${wo}/blueprint_answers`,
      destroy: (wo, id) => `/mobile/interventions/${wo}/blueprint_answers/${id}`,
      update:  (wo, id) => `/mobile/interventions/${wo}/blueprint_answers/${id}`,
      pdf:     (wo, id) => `/mobile/interventions/${wo}/blueprint_answers/${id}/show_pdf`,
      sync:    (wo, id) => `/mobile/interventions/${wo}/blueprint_answers/${id}/sync`,
    },
    field_answers: {
      pictures: {
        create:  (wo, f_a)     => `/mobile/interventions/${wo}/field_answers/${f_a}/pictures`,
        destroy: (wo, f_a, id) => `/mobile/interventions/${wo}/field_answers/${f_a}/pictures/${id}`,
      }
    }
  },
  batchSignatures: {
    index:  technician => `/mobile/batch_signatures.json${technician ? `?technician=${technician}` : ''}`,
    create: '/mobile/batch_signatures.json'
  },
  quoteDemands: {
    index:      '/mobile/quote_demands',
    new:        '/mobile/quote_demands/new',
    show:       id => `/mobile/quote_demands/${id}`,
    edit:       id => `/mobile/quote_demands/${id}/edit`,
    fetch:      id => `/mobile/quote_demands/${id}.json`,
    workorders: '/mobile/quote_demands/workorders.json',
  },
  map: {
    show:       '/mobile/map',
    workorders: (date, technician) => `/mobile/map/workorders.json${mapQuery(date, technician)}`,
    route:      (date, technician) => `/mobile/map/route.json${mapQuery(date, technician)}`
  },
  secondaries: {
    index:     id => `/mobile/interventions/${id}/secondary_workorders.json`,
    startAll:  id => `/mobile/interventions/${id}/secondary_workorders/start_all.json`,
    pauseAll:  id => `/mobile/interventions/${id}/secondary_workorders/pause_all.json`,
    resumeAll: id => `/mobile/interventions/${id}/secondary_workorders/resume_all.json`,
    stopAll:   id => `/mobile/interventions/${id}/secondary_workorders/stop_all.json`,
    closeAll:  id => `/mobile/interventions/${id}/secondary_workorders/close_all.json`,

    start:     id => `/mobile/interventions/${id}/secondary_workorders/start.json`,
    pause:     id => `/mobile/interventions/${id}/secondary_workorders/pause.json`,
    resume:    id => `/mobile/interventions/${id}/secondary_workorders/resume.json`,
    stop:      id => `/mobile/interventions/${id}/secondary_workorders/stop.json`,
    close:     id => `/mobile/interventions/${id}/secondary_workorders/close.json`,

    create:    id => `/mobile/interventions/${id}/secondary_workorders.json`,
    update:    id => `/mobile/secondary_workorders/${id}.json`,
  },
  passages: {
    new:       id => `/mobile/interventions/${id}/passages/new`,
    create:    id => `/mobile/interventions/${id}/passages.json`,
    materials: id => `/mobile/interventions/${id}/passages/fetch_materials`
  },
  products: {
    index:        '/mobile/products',
    new:          '/mobile/products/new',
    create:       '/mobile/products.json',
    scan:         '/mobile/products/scan.json',
    autocomplete: `/mobile/products/autocomplete`,
    show:         id => `/mobile/products/${id}`,
    fetch:        id => `/mobile/products/${id}.json`,
    edit:         id => `/mobile/products/${id}/edit`,
    update:       id => `/mobile/products/${id}.json`,
    stocks:       (productId, userId) => `/products/fetch_stock_for?product_id=${productId}&user_id=${userId}`
  },
  purchase_orders: {
    index:      '/mobile/purchase_orders',
    filter:     '/mobile/purchase_orders.json',
    show:       id => `/mobile/purchase_orders/${id}`,
    fetch:      id => `/mobile/purchase_orders/${id}.json`,
    pdf:        id => `/mobile/purchase_orders/${id}.pdf`,
    pdfNoPrices: id => `/mobile/purchase_orders/${id}.pdf?without_prices=true`,
    receive:    id => `/mobile/purchase_orders/${id}/receive.json`,
    receiveAll: id => `/mobile/purchase_orders/${id}/receive_all.json`,
    receptionPdf: (id, receptionId) => `/mobile/purchase_orders/${id}/receptions/${receptionId}.pdf`
  },
  serializedMaterials: {
    index: '/mobile/units',
    show:  id => `/mobile/units/${id}`,
    fetch: id => `/mobile/units/${id}.json`,
    scan:  '/mobile/units/scan.json',
    move:     id => `/mobile/units/${id}/move.json`,
    remove:   id => `/mobile/units/${id}/remove.json`,
    qualify:  id => `/mobile/units/${id}/qualify.json`,
    sendBack: id => `/mobile/units/${id}/send_back.json`,
    missing:  id => `/mobile/units/${id}/declare_missing.json`,
    slip:     id => `/mobile/units/${id}/return_slip`,
    removeAll: '/mobile/units/remove_all.json',
    replacementCandidates: (productId, materialId) => `/mobile/units/replacement_candidates.json?product_id=${productId}&material_id=${materialId}`
  },
  stocks: {
    inventory: '/mobile/stocks/inventory',
    fetch:     id => `/mobile/stocks/${id}.json`,
    modify:    id => `/mobile/stocks/${id}/modify`,
    move:      id => `/mobile/stocks/${id}/move`,
    update:    id => `/mobile/stocks/${id}.json`,
  },
  inventory_counts: {
    index:             '/mobile/inventory_counts',
    show:        id => `/mobile/inventory_counts/${id}`,
    fetch:       id => `/mobile/inventory_counts/${id}.json`,
    update:      id => `/mobile/inventory_counts/${id}.json`,
    submit:      id => `/mobile/inventory_counts/${id}/submit_for_validation.json`,
    delete_line: id => `/mobile/inventory_counts/${id}/delete_line`
  },
  users: {
    fetch:          '/mobile/users.json',
    account:        '/mobile/users/account.json',
    change_locale:  '/mobile/users/change_locale.json',
    profiles:       '/mobile/users/profiles',
    change_profile: '/mobile/users/change_profile'
  },
  sessions: {
    new:    '/mobile/sessions/new',
    create: '/mobile/sessions.json',
    fetch:  '/mobile/sessions/fetch.json',
    csrf:   '/mobile/sessions/csrf.json'
  },
  demands: {
    index:     '/mobile/demands',
    create:    '/mobile/demands.json',
    fetch:     '/mobile/demands.json',
    desktop:   '/workorder_demands',
    new:       '/mobile/demands/new',
    newPortal: '/mobile/demands/new_portal',
    show:    id => `/mobile/demands/${id}`,
    convert: id => `/mobile/demands/${id}/convert.json`,
    reject:  id => `/mobile/demands/${id}/reject.json`,
    destroy:      id => `/mobile/demands/${id}.json`,
    existingOpen: '/mobile/demands/existing_open.json'
  },
  absences: {
    create: '/mobile/absences.json',
    new:    '/mobile/absences/new'
  },
  hours: {
    index:    '/mobile/hours',
    day:      date => `/mobile/hours/day/${date}`,
    planning: '/mobile/hours/planning',
    team:     '/mobile/hours/team',
    member:   (userId, date) => `/mobile/hours/team/${userId}/${date}`,
    fetch: {
      week:     date => `/mobile/hours.json${date ? `?date=${date}` : ''}`,
      day:      params => `/mobile/hours/day.json?${new URLSearchParams(params)}`,
      planning: '/mobile/hours/planning.json',
      projects: date => `/mobile/hours/projects.json?date=${date}`,
      team:     date => `/mobile/hours/team.json?date=${date}`
    },
    clock:    '/mobile/hours/clock.json',
    sign:     date => `/mobile/hours/sign.json?date=${date}`,
    update:   params => `/mobile/hours/day.json?${new URLSearchParams(params)}`,
    approve:  params => `/mobile/hours/approve.json?${new URLSearchParams(params)}`,
    reject:   params => `/mobile/hours/reject.json?${new URLSearchParams(params)}`,
    reopen:   params => `/mobile/hours/reopen.json?${new URLSearchParams(params)}`,
    entries: {
      create: params => `/mobile/hours/entries.json?${new URLSearchParams(params)}`,
      update: (id, params) => `/mobile/hours/entries/${id}.json?${new URLSearchParams(params)}`,
      delete: (id, params) => `/mobile/hours/entries/${id}.json?${new URLSearchParams(params)}`
    }
  },
  files: {
    index:  (type, id) => `/mobile/files.json?record_type=${type}&record_id=${id}`,
    create: (type, id) => `/mobile/files.json?record_type=${type}&record_id=${id}`
  },
  chat: {
    index:  (type, id) => `/mobile/messages.json?record_type=${type}&record_id=${id}`,
    destroy: id =>        `/mobile/messages/${id}.json`
  },
  diagnostic_chats: {
    show:     (workorderId, materialId) => `/mobile/diagnostic_chats.json?workorder_id=${workorderId}&material_id=${materialId}`,
    messages: (workorderId, materialId) => `/mobile/diagnostic_chats/messages.json?workorder_id=${workorderId}&material_id=${materialId}`
  },
  categories: {
    fields: (id) => `/mobile/categories/${id}/fields`
  }
}
